export const defaultLayoutState = {
    hasHeader: false,
    hasDrawer: false,
    containerMinSize: 'small',
} as const;
